
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: 800, margin: '0 auto', padding: 20 }}>
      <h1>Privacy Policy</h1>
      <p style={{ color: '#888', fontSize: 12 }}>Last Updated: January 22, 2026</p>

      <div style={{ borderLeft: '4px solid #10b981', backgroundColor: '#d1fae5', padding: 10, marginBottom: 20 }}>
        <strong style={{ color: '#065f46' }}>Privacy First</strong>
        <p style={{ color: '#065f46', marginTop: 5 }}>
          Your privacy matters. All your data stays on your device — we don't collect, store, or transmit any personal information or preferences.
        </p>
      </div>

      <h2>Our Commitment to Your Privacy</h2>
      <p>
        Fido ("we," "our," or "the App") is committed to protecting your privacy. This Privacy Policy explains how we handle information when you use our application.
      </p>

      <h2>What We DON'T Collect</h2>
      <ul>
        <li>Your liked or disliked dog preferences</li>
        <li>Your name, email, or any personal identifiers</li>
        <li>Your location data</li>
        <li>Your browsing history within the app</li>
        <li>Any photos or content you view</li>
        <li>Device information beyond what's required for the app to function</li>
      </ul>

      <h2>Local Storage Only</h2>
      <p>All preferences (liked/disliked dogs) are stored locally on your device:</p>
      <ul>
        <li>Your data never leaves your device</li>
        <li>No server stores your data</li>
        <li>If you delete the app, all data is permanently removed</li>
      </ul>

      <h2>Third-Party Image Services</h2>
      <p>
        Some breed images are loaded from third‑party services such as Unsplash, Pexels, Pixabay, Flickr, and Wikimedia Commons. These services may collect information about your device and usage through cookies, IP addresses, analytics, and log data according to their own privacy policies. We do not control these third parties’ data practices. Please review their respective privacy policies:
      </p>
      <ul>
        <li><a href="https://unsplash.com/privacy" target="_blank" rel="noopener noreferrer">Unsplash Privacy Policy</a></li>
        <li><a href="https://www.pexels.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Pexels Privacy Policy</a></li>
        <li><a href="https://pixabay.com/service/terms/" target="_blank" rel="noopener noreferrer">Pixabay Privacy Policy</a></li>
        <li><a href="https://www.flickr.com/help/privacy" target="_blank" rel="noopener noreferrer">Flickr Privacy Policy</a></li>
        <li><a href="https://foundation.wikimedia.org/wiki/Policy:Privacy_policy" target="_blank" rel="noopener noreferrer">Wikimedia Privacy Policy</a></li>
      </ul>

      <h2>No Tracking or Analytics</h2>
      <p>We do not use analytics, tracking tools, or ads. Your usage is completely private.</p>

      <h2>No Accounts Required</h2>
      <p>You do not need to create an account or provide any personal information to use the app.</p>

      <h2>Data Security</h2>
      <p>Since all data is stored locally on your device:</p>
      <ul>
        <li>Keep your device OS updated</li>
        <li>Use device encryption if available</li>
        <li>Use a secure lock screen</li>
      </ul>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy. Changes will be reflected by updating the "Last Updated" date above. Review periodically.
      </p>

      <h2>Contact Us</h2>
      <p>If you have any questions, contact us through the App Store listing.</p>
    </div>
  );
};

function App() {
  return <PrivacyPolicy />;
}

export default App;
